import { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import KeyRoundIcon from '@liquidweb-dev/undercurrent/icons/lucide/KeyRound';
import DialogUTM from 'components/standard/DialogUTM';
import GettingStartedImg from 'images/utm/getting-started.png';

interface GettingStartedProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
}

const GettingStarted = ({ onClose, ...dialogProps }: GettingStartedProps) => {
	return (
		<DialogUTM
			{...dialogProps}
			image={GettingStartedImg}
			badge={{
				icon: KeyRoundIcon,
				label: 'Getting Started',
			}}
			dialogContent={{
				title: 'Your server was recently created',
				description: (
					<Typography variant="body-md">
						You can check your server&apos;s status in the <b>Servers</b> list.
						Once it&apos;s ready, go to the server&apos;s <b>Overview</b> tab to
						find your Server Credentials.
						<br />
						<br />
						You are now ready to log in with SSH or the console to begin
						configuring your new environment.
					</Typography>
				),
			}}
			onClose={onClose}
		/>
	);
};

export default GettingStarted;
